// File utility functions for upload validation and display

export function formatFileSize(bytes) {
  if (!bytes || bytes === 0) return '0 B';
  var units = ['B', 'KB', 'MB', 'GB'];
  var i = 0;
  var size = bytes;
  while (size >= 1024 && i < units.length - 1) {
    size /= 1024;
    i++;
  }
  return size.toFixed(i > 0 ? 1 : 0) + ' ' + units[i];
}

export function getFileExtension(filename) {
  if (!filename) return '';
  var parts = filename.split('.');
  return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
}

export function isImageFile(filename) {
  var ext = getFileExtension(filename);
  return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'].indexOf(ext) >= 0;
}

export function isPDFFile(filename) {
  return getFileExtension(filename) === 'pdf';
}

export function validateFile(file, validation) {
  if (!file || !validation) return null;

  // Check file size
  var maxMB = validation.max_file_size_mb || 50;
  var maxBytes = maxMB * 1024 * 1024;
  if (file.size > maxBytes) {
    return 'File size (' + formatFileSize(file.size) + ') exceeds the ' + maxMB + ' MB limit';
  }

  // Check extensions
  var allowed = validation.allowed_extensions;
  if (allowed && allowed.length > 0) {
    var ext = getFileExtension(file.name);
    var normalized = allowed.map(function(e) { return e.toLowerCase().replace(/^\./, ''); });
    if (normalized.indexOf(ext) < 0) {
      return 'File type .' + ext + ' is not allowed. Accepted types: ' + normalized.map(function(e) { return '.' + e; }).join(', ');
    }
  }

  return null;
}

export function getAcceptAttribute(validation) {
  if (!validation || !validation.allowed_extensions || validation.allowed_extensions.length === 0) return undefined;
  return validation.allowed_extensions.map(function(e) {
    var ext = e.toLowerCase().replace(/^\./, '');
    return '.' + ext;
  }).join(',');
}
